<template>
	<div class="form__group">
		<multiselect
            :options="results"
            :placeholder="placeholder"
            :allow-empty="allowEmpty"
            label="name"
            track-by="id"
            :searchable="true"
            :loading="loading"
            :internal-search="false"
            :multiple="multiple"
            :options-limit="10"
            :show-labels="false"
            @search-change="onSearchChange"
            v-model="selected"
            :class="{ 'form__control': true, 'form__control--invalid': errors.first(this.name) }"
        >
			<span slot="noOptions">Type a name to search members...</span>
		</multiselect>
		<label class="form__label">{{ label }}</label>
        <a
            href="#"
            @click.prevent.stop="clearValue"
            class="form__clear"
            v-if="this.selected || (this.selected && this.selected.length > 0)"
        >
            Clear
        </a>
		<div class="form__validation" slot="validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import API from './../../../api';
	import AjaxSelect from './AjaxSelect';

	export default {
		name: 'FormControlMember',
		mixins: [AjaxSelect],
		props: {
			label: {
				type: String,
				default: 'Select member',
			},
			placeholder: {
				type: String,
				default: 'Select a member...',
			}
		},
		methods: {
			search(query) {
				API.getMembers({
					query
				}).then(members => {
					this.results = members;
				}).finally(() => this.loading = false);
			},
			getItemFromCache(id) {
				return this.$store.getters['selectCache/getMember'](id);
			},
			addItemToCache(member) {
				this.$store.commit('selectCache/addMember', member);
			}
		},
	}
</script>
